import { graphql } from '@gql/types';

export const TOUR_TICKET_SALES_QUERY = graphql(`
  query TourTicketSales($tourId: ID!) {
    tourTicketSales(tourId: $tourId) {
      tour {
        id
        name
        headliner
        coHeadliners
        company
        isMultiLegTour
        buyer
        operator
      }
      venues {
        venueId
        venueName
        shows {
          showId
          showDate
          allocations {
            allocationId
            ticketCompanyName
            ticketType
            ticketName
            allocation
            price
            lastUpdate
            manualSales
            canModifyAdjustments
          }
        }
      }
    }
  }
`);
